export default "__VITE_ASSET__C89kpw8L__"